{
	"meta": {
		"title": "Funciones — UpSquad",
		"description": "Todas las herramientas que tu organización necesita — unificadas, con IA y bellamente sencillas. Explora el conjunto completo de funciones de UpSquad."
	},
	"hero": {
		"eyebrow": "Funciones",
		"title": "Diseñado para cómo funcionan",
		"title_accent": "las comunidades de verdad.",
		"subtitle": "Once funciones. Una plataforma unificada. Todas las herramientas que tu organización necesita para impulsar una comunidad próspera — sin hacer malabares con diez apps."
	},
	"premium_badge": "Premium",
	"try_it_free": "Pruébalo gratis",
	"frames": {
		"feed": "Feed de la comunidad en la app web",
		"messaging": "Mensajes en la app web",
		"events": "Eventos en la app web",
		"meetings": "Reuniones con calendario en la app web",
		"clips": "Clips de la comunidad en la app móvil",
		"match": "Sugerencias de Match AI en la app web",
		"insights": "AI Insights en la app web",
		"members": "Lista de miembros en la app web",
		"analytics": "Panel de analíticas en la app web",
		"branded": "Vista previa de la app móvil con tu marca, tema {{theme}}",
		"theming": "Ajustes de la comunidad con selector de tema"
	},
	"items": {
		"feed": {
			"eyebrow": "Feed social",
			"title": "Mantén tu comunidad en movimiento.",
			"bullets": [
				"Posts, encuestas, vídeos y archivos — todo en un mismo feed",
				"Filtra por grupo, tipo de contenido o recencia",
				"Reacciones, comentarios, marcadores y posts fijados"
			]
		},
		"messaging": {
			"eyebrow": "Mensajería",
			"title": "Cada conversación en un solo lugar.",
			"bullets": [
				"Canales de grupo para cohortes, equipos o programas",
				"Mensajes directos con confirmación de lectura",
				"Adiós al 'revisa tu correo' y a las pestañas dispersas de Slack"
			]
		},
		"events": {
			"eyebrow": "Eventos",
			"title": "Organiza eventos a los que la gente sí va.",
			"bullets": [
				"Crea eventos gratuitos o de pago en minutos",
				"RSVP, registro y asistencia integrados",
				"Vista de calendario integrada — los miembros ven lo que viene"
			]
		},
		"meetings": {
			"eyebrow": "Reuniones",
			"title": "1:1 y reuniones de grupo programadas con IA.",
			"bullets": [
				"Programa reuniones directamente desde tu comunidad",
				"La IA redacta agendas con un clic",
				"Match AI sugiere quién debería reunirse según objetivos"
			]
		},
		"clips": {
			"eyebrow": "Clips de comunidad",
			"title": "Comparte historias que construyen cultura.",
			"bullets": [
				"Vídeos cortos de comunidad, formato vertical",
				"Los miembros comparten momentos, aprendizajes e inspiración",
				"Mantiene la energía alta entre eventos en vivo"
			]
		},
		"match": {
			"eyebrow": "Match AI",
			"title": "El motor de networking de tu comunidad.",
			"bullets": [
				"Analiza perfiles, objetivos y actividad de los miembros",
				"Recomienda las conexiones adecuadas en el momento correcto",
				"Los miembros agendan una reunión 1:1 con un clic desde un match"
			]
		},
		"insights": {
			"eyebrow": "AI Insights",
			"title": "Inteligencia sobre tu comunidad, cuando la necesites.",
			"bullets": [
				"Pregunta en lenguaje natural sobre los datos de los miembros",
				"Obtén respuestas instantáneas basadas en tu actividad real",
				"Reportes semanales automatizados directamente a tu inbox"
			]
		},
		"members": {
			"eyebrow": "Gestión de miembros",
			"title": "Conoce a tus miembros. Lleva tus programas.",
			"bullets": [
				"Directorio buscable con filtros por grupo",
				"Indicadores de última actividad para que nadie se pierda",
				"Cobra pagos, gestiona roles y administra cohortes"
			]
		},
		"analytics": {
			"eyebrow": "Analítica",
			"title": "Datos reales. Decisiones reales.",
			"bullets": [
				"Crecimiento, engagement y asistencia a eventos de un vistazo",
				"Exporta reportes para stakeholders y financiadores",
				"Impulsado por la misma capa de datos que AI Insights"
			]
		},
		"branded": {
			"eyebrow": "App móvil con marca",
			"title": "Tu comunidad. Tu app. Setenta y dos horas.",
			"bullets": [
				"App de iOS y Android totalmente personalizada con tu logo y colores",
				"En la App Store en tan solo tres días",
				"Actualizaciones automáticas — sin desarrolladores, nunca"
			]
		},
		"theming": {
			"eyebrow": "Temas de comunidad",
			"title": "Cada comunidad luce como la tuya.",
			"bullets": [
				"Elige entre cuatro temas distintivos o el tuyo propio",
				"Tu URL personalizada: tuorg.upsquad.us",
				"Sube tu logo y portada en dos clics"
			]
		}
	},
	"closing": {
		"title": "¿Lista para verlo en acción?",
		"subtitle": "Empieza gratis sin tarjeta de crédito, o reserva una demo de 30 minutos con nuestro equipo.",
		"cta_primary": "Crear cuenta gratis",
		"cta_secondary": "Reservar una demo"
	}
}
